///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { ProgressServiceConfig } from '../../core/data/progress-service-config';
import { DpTransparentRacuni } from './racuni.model';

export function getRacuniConfig(): ProgressServiceConfig {
    return {
        dataProviderName: 'dpTransparent',
        serverOperations: false,
        createModel: () => new DpTransparentRacuni(),
        mapData: dataItem => {
            dataItem.DatDk = new Date(dataItem.DatDk);
            dataItem.Valuta = new Date(dataItem.Valuta);

            return dataItem;
        },
        jsdo: {
            name: 'Racuni',
        },
        ds: {},
    };
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/data/dp-transparent/racuni.config.ts